import api from "./api";

export const fetchFAQs =
    async () => {
        try {
            const response =
                await api.get(
                    "/faq-management/faqs/?archived=false"
                );

            return {
                success: true,
                data:
                    response.data
                        .data,
            };
        } catch (
            error
        ) {
            return {
                success: false,
                error:
                    error
                        ?.response
                        ?.data
                        ?.detail ||
                    "Failed to fetch FAQs.",
            };
        }
    };